import { useFormatUserDate } from 'hooks';

import { useFormRowContext } from './FormRowContext';

export const UpdatedAtCell = () => {
  const {
    form: { updatedAt },
  } = useFormRowContext();
  const formatUserDate = useFormatUserDate();

  return <td>{formatUserDate(updatedAt)}</td>;
};
